import type { SVGProps } from 'react';

const DefaultSvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M20 13.75 16 16l-4-2.25v-4.5L16 7l4 2.25v4.5Zm-5 9v-4.5L11 16l-4 2.25v4.5L11 25l4-2.25Zm10-4.5v4.5L21 25l-4-2.25v-4.5L21 16l4 2.25Z"
      clipRule="evenodd"
    />
  </svg>
);
export default DefaultSvgIcon;
